import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;

  display: flex;
  gap: 36px;

  align-items: center;

  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray[600]};

  select {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[600]};
    background-color: transparent;
    margin-left: 11px;

    outline: none;

    padding: 4px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 30px;
  margin-right: 16px;
  align-items: center;

  button {
    border: none;
    background: none;

    svg {
      stroke: ${({ theme }) => theme.colors.orange.primary};
    }

    &:disabled {
      cursor: not-allowed;

      svg {
        stroke: ${({ theme }) => theme.colors.gray[500]};
      }
    }
  }
`;
